import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { SpacetimeDBQueryClient } from "spacetimedb/tanstack";

import { routeTree } from "./routeTree.gen";

export interface RouterAppContext {
  queryClient: QueryClient;
  spacetimeDBQueryClient: SpacetimeDBQueryClient;
}

// Per-request factory. Each Worker request constructs its own router so no
// state is shared across requests. See TANSTACK_START_MIGRATION.md §1.3.
// TODO(fas): add posthog to the server context
export function getRouter() {
  const spacetimeDBQueryClient = new SpacetimeDBQueryClient();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        queryFn: spacetimeDBQueryClient.queryFn,
      },
    },
  });
  spacetimeDBQueryClient.connect(queryClient);

  const context: RouterAppContext = { queryClient, spacetimeDBQueryClient };

  const router = createRouter({
    routeTree,
    context,
    scrollRestoration: true,
  });

  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
